import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvZipHubUpload = async (
  { rootGetters },
  { clientSid, email, selectedCsvTypes }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const client = await stbApi.postCsvZipHubUpload({}, clientSid, email, selectedCsvTypes);
  return client;
};
